import React from "react";
import { Link, useLocation } from "react-router-dom";
import { SignedIn, SignedOut, SignInButton, UserButton } from '@clerk/clerk-react'
import logo from "../assets/logo.png";

const Header = () => {
  const location = useLocation();

  const items = [
    { label: "Home", path: "/home" },
    { label: "About", path: "/#about" },
    { label: "Services", path: "/#services", dropdown: true },
    { label: "Testimonials", path: "/#testimonials" },
    { label: "English", path: "#", dropdown: true, globe: true },
  ];

  const isActive = (path) => location.pathname === path || (path === "/home" && location.pathname === "/");

  return (
    <header className="absolute inset-x-0 top-0 z-50 bg-transparent">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" className="flex-shrink-0">
          <img src={logo} alt="Legaily Logo" className="h-16 w-auto" />
        </Link>

        <nav className="flex-1 mx-8">
          <ul className="flex items-center justify-center gap-6">
            {items.map((item) => (
              <li key={item.label}>
                <Link
                  to={item.path === "#" ? location.pathname : item.path}
                  className={`${
                    isActive(item.path)
                      ? "bg-white/70 text-gray-800 shadow-sm"
                      : "text-gray-700 hover:text-gray-900"
                  } px-3 py-1.5 rounded-full text-sm transition-colors flex items-center gap-1`}
                >
                  {item.globe && (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 text-gray-600">
                      <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm7.93 9h-3.18a15.95 15.95 0 00-1.17-5.02A8.02 8.02 0 0119.93 11zM12 4c1.53 0 3.01 2.27 3.67 6H8.33C8.99 6.27 10.47 4 12 4zM4.07 13h3.18c.23 1.76.66 3.45 1.17 5.02A8.02 8.02 0 014.07 13zM4.07 11a8.02 8.02 0 013.35-5.02C6.91 7.55 6.48 9.24 6.25 11H4.07zm7.93 9c-1.53 0-3.01-2.27-3.67-6h7.34c-.66 3.73-2.14 6-3.67 6zm3.43-1.98c.51-1.57.94-3.26 1.17-5.02h3.18a8.02 8.02 0 01-4.35 5.02z" />
                    </svg>
                  )}
                  <span>{item.label}</span>
                  {item.dropdown && (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3.5 h-3.5 text-gray-600">
                      <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.207l3.71-2.977a.75.75 0 01.94 1.172l-4.24 3.4a.75.75 0 01-.94 0l-4.24-3.4a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                    </svg>
                  )}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="flex-shrink-0">
          <SignedOut>
            <SignInButton mode="modal" />
          </SignedOut>
          <SignedIn>
            <UserButton afterSignOutUrl="/" />
          </SignedIn>
        </div>
      </div>
    </header>
  );
};

export default Header;
